import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPipette = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 71.998543,
			d: "M866.633 323.49c49.86-49.86 49.858-130.821.006-180.673-49.86-49.86-130.82-49.86-180.68-.001L529.325 299.45l-48.704-48.704L360.606 370.76l278.082 278.082 120.015-120.014-48.705-48.704z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 71.998543,
			d: "M589.984 600.138 365.1 825.023l-176.843-3.822-3.237-176.258-.594-.593 224.886-224.886M188.259 821.198l-68.277 68.277"
		})
	]
});
export default SvgIconPipette;
